import { mapGetters } from "vuex";
import { gsap, Cubic } from "gsap";
import router from "../../../../../router";
import * as STEPPER_GETTER from "../../../../../store/stepper/getter-types";
import { GET_BOOKING,GET_BOOKING_DISCOUNT, GET_AGGREGATE_EXTRA_PRICE, GET_BOOKING_TRAVELLERS_TOTAL, GET_FLEX_EXTRA_SELECTED } from '../../../../../store/booking/getter-types';
import { ucfirst } from "../../../../../utils/strings";
import moment from "../../../../../plugins/moment";


export default {
  // mixins: [stepMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: () => "Resumen de la reserva"
    },
    date: {
      type: String,
      required: false,
      default: () => ""
    },
    origin: {
      type: String,
      required: false,
      default: () => ""
    },
    destiny: {
      type: String,
      required: false,
      default: () => ""
    },
    travellersTotal: {
      type: Number,
      required: false,
      default: () => undefined
    },
    travellerPrice: {
      type: Number,
      required: false,
      default: () => 0
    },
    totalPrice: {
      type: Number,
      required: false,
      default: () => undefined
    },
    fixedTotalPrice: {
      type: Boolean,
      required: false,
      default: () => false
    },
    bookingExtras: {
      type: Array,
      required: false,
      default: () => []
    },
    extras: {
      type: String,
      required: false,
      default: () =>
        ""
    },
    expansionPanelHeight: {
      type: Number,
      required: false,
      default: () => 300
    }
  },
  data() {
    return {
      iphone: false,
      collapsible: {
        isOpen: false,
        label: this.$t('shared.show_details'),
        tl: null
      },
      travellers: {
        icon: "/img/icons/user.svg",
        label: `${this.travellersTotal} ${this.travellersTotal > 1 ? 'pasajeros' : 'pasajero'}`
      },
      summaryItems: [
        {
          icon: "/img/icons/airplane.svg",
          label: ucfirst(`${this.$t('shared.from')} ${this.origin}`)
        },
        {
          icon: "/img/icons/user.svg",
          label: `${this.travellersTotal} ${this.$tc('shared.passenger', this.travellersTotal)}`
        },
        {
          icon: "/img/icons/calendar.svg",
          label: this.date
        },
        {
          icon: "/img/icons/location.svg",
          label: `${this.$t('shared.destiny')} ${this.destiny}`
        }
      ].filter(item => item.label)
    };
  },
  computed: {
    ...mapGetters({
      stepper: STEPPER_GETTER.GET_STEPPER,
      discount: GET_BOOKING_DISCOUNT,
      totalPassengers: GET_BOOKING_TRAVELLERS_TOTAL,
      flexExtraSelected: GET_FLEX_EXTRA_SELECTED
    }),
    selectedExtrasCount() {
      return this.gifts ?
        0 :
        this.$store.state.booking.extras.available.filter(extra => {
          return extra.selected && (! extra.hasCounter || extra.quantity);
        }).length;
    },
    isIphone(){
      if(navigator.userAgent.match(/iPhone|iPad|iPod/i)){
          return 'padding-fixed-summary';
      }else{
        return '';
      }
    },
    booking(){
      return this.$store.getters[GET_BOOKING];
    },
    outgoingDeparture(){
      return this.booking.outgoingFlight.departure && moment(this.booking.outgoingFlight.departure.datetime).format('LT');
    },
    outgoingArrival(){
      return this.booking.outgoingFlight.arrival && moment(this.booking.outgoingFlight.arrival.datetime).format('LT');
    },
    returnDeparture(){
      return this.booking.returnFlight.departure && moment(this.booking.returnFlight.departure.datetime).format('LT');
    },
    returnArrival(){
      return this.booking.returnFlight.arrival && moment(this.booking.returnFlight.arrival.datetime).format('LT');
    },
    summaryItemsIn(){
      return [
        {
          icon: "/img/icons/airplane.svg",
          label: `${this.origin} (${this.$route.query.origen}) - ${this.destiny} (${this.$route.query.destino})`
        },
        {
          icon: "/img/icons/calendar.svg",
          label: `${this.date} · ${this.outgoingDeparture} - ${this.outgoingArrival}`
        },
      ]
    },
    summaryItemsOut(){
      return [
        {
          icon: "/img/icons/arrive.svg",
          label: `${this.destiny} (${this.$route.query.destino}) - ${this.origin} (${this.$route.query.origen})`
        },
        {
          icon: "/img/icons/calendar.svg",
          label: `${this.date} · ${this.returnDeparture} - ${this.returnArrival}`
        },
      ]
    }
  },
  mounted() {
    this.initExpansionPanel();
  },
  methods: {
    submitStep() {
      this.$emit("stepComplete");
    },
    initExpansionPanel() {
      const summaryTl = gsap.timeline({
        paused: true,
        reversed: true
      });
      gsap.timeline().set(".collapsible-section", {
        height: 0,
        autoAlpha: 0,
        display: "none"
      });
      summaryTl.to(".collapsible-section", 1, {
        delay: 0,
        height: 600 + (30 * this.selectedExtrasCount),
        autoAlpha: 1,
        display: "block",
        ease: Cubic.easeInOut
      });
      this.collapsible.tl = summaryTl;
    },
    toogleExpansionPanel(fromRouteChange) {
      if (fromRouteChange && ! this.isOpen) {
        return;
      }
      this.isOpen = !this.isOpen;
      this.$eventHub.$emit("update-overlay", this.isOpen);
      this.collapsible.tl.reversed()
        ? this.collapsible.tl.play()
        : this.collapsible.tl.reverse();
      setTimeout(() => {
        this.collapsible.label = this.isOpen
          ? this.$t('shared.hide_details')
          : this.$t('shared.show_details');
      }, 800);
    },
    getAggregateExtraPrice(extra) {
      return this.$store.getters[GET_AGGREGATE_EXTRA_PRICE](extra);
    }
  },
  watch: {
    selectedExtrasCount() {
      this.initExpansionPanel();
    }
  },
  created() {
    window.Events.$on('route-will-change', () => this.toogleExpansionPanel(true));
  }
};